import { render, staticRenderFns } from "./GrandedForLogged.vue?vue&type=template&id=a487ad5e"
import script from "./GrandedForLogged.vue?vue&type=script&lang=js"
export * from "./GrandedForLogged.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports